module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-barrel-shadow-3.8ffb6e88.png";